export default __webpack_public_path__ + "img/0d804b375eb722f420bde9447284467b.svg";